import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '@/store/api/baseQuery';
import { setLoading } from '@/store/reducers/authSlice';

export interface CreateUserEntityRequest {
  emailId: string;
  firstName: string;
  lastName: string;
}

interface IUserMappingWithEmailresponse{
  mappingId: string;
  contactId: string;
  userId: string;
  createdDate: string | null;
}

interface ContactUserMappingRequest {
  contactId: string;
  emailId: string;
}

export const appApi = createApi({
  reducerPath: 'appApi',

  baseQuery,

  tagTypes: ['App'],

  endpoints: (builder) => ({
    createUserEntity: builder.mutation<void, CreateUserEntityRequest>({
        query: (body) => ({
          url: '/api/user',
          method: 'POST',
          body,
        }),
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          dispatch(setLoading(true));
          try {
            await queryFulfilled;
            dispatch(setLoading(false));
          } catch {
            dispatch(setLoading(false));
          }
        },
      }),
      contactUserMapping: builder.mutation<void, ContactUserMappingRequest>({
        query: (body) => ({
          url: `/api/user/mapping`,
          method: 'POST',
          body: body,
        }),
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          dispatch(setLoading(true));
          try {
            await queryFulfilled;
            dispatch(setLoading(false));
          } catch {
            dispatch(setLoading(false));
          }
        },
      }),
      contactUserMappingWithEmail: builder.mutation<IUserMappingWithEmailresponse, {email: string}>({
        query: ({ email }) => ({
          url: `/api/user/mapping/email?email=${email}`,
          method: 'POST',
          body: {},
        }),
        async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
          dispatch(setLoading(true));
          try {
            await queryFulfilled;
            dispatch(setLoading(false));
          } catch {
            dispatch(setLoading(false));
          }
        },
      }),
  }),
});

export const {
  useCreateUserEntityMutation,
  useContactUserMappingMutation,
  useContactUserMappingWithEmailMutation,
} = appApi;